/*
 * provtable - Table utilities
 */
provtable={
    addRow: function (table, html, addTop) {
    	
        var tableBody = $(">tbody", table);
        var origHtml =html;
        
        var start = html.indexOf('<INNERscript');
        
		//contains a nested dynamic add, need preprocess
		if(start!=-1)
		{
   
		html = html.replace(/INNERscript/g,'script');
        origHtml =html;
       
        origHtml = html;
        var s= html.indexOf("<a");//first occurance of <a
        var e= html.lastIndexOf("</script>") //last occurance of </script>
        origHtml= html.substring(s,e) + "</script>";
        
        //addButtonHtml needs \" instead of "
        regExpStart = /addButtonHtml/g;
		regExpEnd = /addButtonSelector/g;
		
		numOfDynamic= html.match(/<script/g).length;
		var startIndexes= new Array(numOfDynamic);
		var endIndexes= new Array(numOfDynamic);
		var htmlTemps= new Array(numOfDynamic);
		
		i=0;
		while(mStart = regExpStart.exec(origHtml)){
			startIndexes[i]=mStart.index;
			i++;
		}
		
		i=0;
		while(mEnd = regExpEnd.exec(origHtml)){
			endIndexes[i]= mEnd.index + (("addButtonSelector").length); //add back the "addButtonSelector"
			i++;
		}
		
		for(i=0; i<numOfDynamic; i++)
		{		
			
			htmlTemps[i]=origHtml.substring(startIndexes[i] +("addButtonHtml").length + 3, endIndexes[i] - ("addButtonSelector").length -2 ).replace(/"/g, '\\"');
			htmlTemps[i] = "addButtonHtml: \"" + htmlTemps[i] + "\",addButtonSelector";//don't want to touch the " at beginning and end, but need to save the content
		}
        
		//compose it back
		
		//origHtml = origHtml.substring(0, startIndexes[0])+ htmlTemps[0] + origHtml.substring(endIndexes[0], startIndexes[1]) + htmlTemps[1] + origHtml.substring(endIndexes[1]);
	
		htmlNew = origHtml.substring(0, startIndexes[0])+ htmlTemps[0];
		for(i=0; i<numOfDynamic-1; i++)
		{				
			htmlNew = htmlNew + origHtml.substring(endIndexes[i], startIndexes[i+1]) + htmlTemps[i+1] ;		
		}
		htmlNew = htmlNew + origHtml.substring(endIndexes[numOfDynamic-1]);
		origHtml=htmlNew;
		
		
		//saved the entire dynamic td body since wrapInner mess it up 		
        var myTag ="<div class=\"DynamicAdd\" id=\"DynamicAdd\"></div>";
        html = html.replace(/<a(.*)<\/script>/g, myTag);
		}//end preprocess
		
        var t = $(html).find("td").wrapInner("<div style='display:none;'/>").parent();
        if (addTop) t.prependTo(tableBody);
        else t.appendTo(tableBody);
        
        t.removeAttr("id").show().find("td div").slideDown(500, function () {
            $(this).each(function () {
                var set = $(this); 
                if (set.hasClass("DynamicAdd"))
                	set.replaceWith(origHtml); 
                else set.replaceWith(set.contents());
            }).end()
        })
        return false;
    },
    
    removeRow: function (table, html, removeTop) {
        var t;
        if (removeTop) t = table.find('tbody tr:first')
        else t = table.find('tbody tr:last');
        t.find("td")
        .wrapInner("<div  style='DISPLAY: block'/>")
        .parent().find("td div")
        .slideUp(500, function () {
            $(this).parent().parent().remove();
        });
        return false;
    }
}